import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Logo } from "./MarketingHeader";

export const MarketingFooter = ({ content, phone, phoneDisplay }) => {
  return (
    <footer className="bg-[#19294C] text-white py-12 px-6 md:px-12" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <Logo light />
          <div className="flex items-center gap-6">
            {phone && (
              <a
                href={`tel:${phone}`}
                className="flex items-center gap-2 text-sm text-white/80 hover:text-[#00B8E4] transition-colors"
              >
                <Phone className="w-4 h-4" />
                {phoneDisplay || content.phone}
              </a>
            )}
            <Link to="/connexion" className="text-sm text-white/60 hover:text-white transition-colors">
              Espace client
            </Link>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">{content.rights}</p>
          <div className="flex items-center gap-4 text-sm text-white/40">
            <Link to="/conditions-generales-de-vente" className="hover:text-white/70 transition-colors" data-testid="footer-link-cgv">
              CGV
            </Link>
            <Link to="/politique-de-confidentialite" className="hover:text-white/70 transition-colors" data-testid="footer-link-privacy">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
